import { marked } from 'marked'
import { logger } from '../util/log.util.js'
import { sentry } from '../util/sentry.util.js'

export class MarkdownService {
  parse(txt: string): string {
    let htmlValue: string

    // We receive an error occasionally where txt.at is not a function. This
    // try catch is temporary debugging to try to figure out what is causing it.
    try {
      htmlValue = marked.parse(txt) as string
    } catch (err) {
      logger.error('Error', err, 'while parsing markdown', txt)
      sentry.captureException(err)
      htmlValue = txt
    }

    // add comment explaining why we need this
    const count = (htmlValue.match(/<p>/g) || []).length

    if (count === 1 && htmlValue.startsWith('<p>')) {
      htmlValue = htmlValue.replace(/^<p>(.+)<\/p>\s*$/g, '$1')
    }

    return '<md>' + htmlValue + '</md>'
  }
}

export const markdownService = new MarkdownService()
